<template>
    <div class="popup">
        <div class="popup-inner">
            <div class="col-md-12">
                <div class="card card-container pt-0 pr-0">
                    <v-row no-gutters>
                        <v-col>

                            <h3 class="subtitle is-4 mt-8">Bitte Passwort eingeben:</h3>
                        </v-col>
                        <v-col cols="1">

                            <v-icon icon="mdi-close" @click="close"/>
                        </v-col>
                    </v-row>
                    <Form v-on:submit.prevent="changeProfile" >
                        <v-responsive
                                class="mx-auto mr-10 mt-4"
                                max-width="344"
                        >
                            <v-text-field
                                    label="Passwort"
                                    v-model="this.passwort"
                                    type="password"
                                    variant="outlined"
                            />
                        </v-responsive>
                        <v-row>
                            <v-col>
                            <div>
                                <v-btn @click="changeProfile"  class="mb-2 mr-10 float-right" :disabled="this.isDataComplete()"
                                       style="background-color: var(--merkur-bg-color); color: white; width: 105px;">
                                    Abschicken
                                </v-btn>
                            </div>
                            </v-col>
                            <v-col>
                                <div v-if="message" class="alert alert-danger mr-10" role="alert">
                                    {{ message }}
                                </div>
                            </v-col>
                        </v-row>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CompanyDataService from "@/services/company.service";

export default {
  name: "ChangeProfile",
  props: ['TogglePopup',"companyID","oldValue"],
  data() {
    return {
      passwort:"",
      message:"",
    };
  },
  computed:{
    currentUser() {
      if(this.$store.state.auth.user){
        let user = this.$store.state.auth.user
        return user
      }
      return null;
    },
  },
  methods:{
    isDataComplete() {
      return !(this.passwort);
    },
    changeProfile(){
      CompanyDataService.changeCompany(this.companyID,this.passwort).then(response => {
        let user = response.data
        user.loginTime = new Date()
        localStorage.setItem('user', JSON.stringify(user));
        this.$store.dispatch("auth/changeProfil", user)
        CompanyDataService.getCompany(this.companyID).then(result => {
          this.$store.dispatch("company/saveCompanyAction",result.data)
          window.location.reload()
        }).catch(err => {
          console.log(err)
        })

      }).catch(err => {
          if(err.response.data.message === "Passwort Falsch") {
              this.message = err.response.data.message
          }
        console.log(err)
      })
    },
    close(){
      this.$emit('resetProfile',this.oldValue)
    }
  }
}
</script>

<style scoped>
.popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.5);

    display: flex;
    align-items: center;
    justify-content: center;
}

.popup-inner {
    padding: 64px;
    width: 500px;
}

label {
    display: block;
    margin-top: 10px;
}

.card-container.card {
    max-width: 450px !important;
    padding: 20px 30px;
}

.card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
}
</style>